'use client'
import { clsx } from 'clsx'

import { FC } from 'react'

import {
  pseudoAfter,
  pseudoBefore,
} from '@/app/module/layout/elements/header/constants/header.constants'
import { styles } from '@/app/shared/components/burger-wrapper/constants'
import {
  getTypeSitePseudo,
  styleMobileModal,
} from '@/app/shared/components/burger-wrapper/services'
import { BurgerMenuComponent } from '@/app/shared/components/modals/burger-menu'
import {
  getColorBgSite,
  getColorBorderSite,
  getColorBtnSite,
} from '@/app/shared/components/modals/modal/services'
import useScreenWidth from '@/app/shared/hooks/useScreenWidth'
// import useScrollToBlock from '@/app/shared/hooks/useScrollToBlock'
import { IClassName } from '@/app/shared/interfaces/common.interface'
import useLayout from '@/app/shared/store/layout.store'
import useModal from '@/app/shared/store/modals.store'
import { ButtonComponent } from '@/app/shared/ui/button'
import { PopoverComponent } from '@/app/shared/ui/popover'
// import route = us

// interface
interface IBurgerWrapper extends IClassName {}

// component
const BurgerWrapperComponent: FC<Readonly<IBurgerWrapper>> = ({ className }) => {
  const { isDesktop } = useScreenWidth()
  // const { checkHashRoute } = useScrollToBlock()
  const open = useModal((state) => state.open)
  const typeSite = useLayout((state) => state.typeSite)

  const handleOpenModal = () => {
    open({
      name: 'BurgerMenu',
      component: BurgerMenuComponent,
      additional: {
        size: 'full',
        classNames: styleMobileModal(getColorBtnSite(typeSite)),
      },
    })
  }

  // useEffect(() => {
  //   checkHashRoute(window.location.hash)
  // }, [checkHashRoute])

  // return
  return (
    <>
      {!isDesktop ? (
        <ButtonComponent
          className={clsx(
            'flex h-10 w-[63px] flex-shrink-0 items-center justify-center bg-white p-0',
            className,
          )}
          onClick={handleOpenModal}
        >
          <span
            className={clsx(
              'relative block h-[19px] w-[33px] border-b-2 border-t-2',
              getColorBorderSite(typeSite),
            )}
          >
            <span
              className={clsx(
                'absolute top-1/2 block h-0.5 w-full -translate-y-1/2',
                getColorBgSite(typeSite),
              )}
            ></span>
          </span>
        </ButtonComponent>
      ) : (
        <PopoverComponent
          trigger={
            <ButtonComponent
              className={clsx(
                'flex h-10 w-[63px] flex-shrink-0 items-center justify-center bg-content1-200 p-0 hover:[&>span]:before:-translate-y-0.5 hover:[&>span]:after:translate-y-0.5',
                className,
              )}
            >
              <span
                className={clsx(
                  'relative block h-[19px] w-[33px]',
                  pseudoBefore,
                  pseudoAfter,
                  getTypeSitePseudo(typeSite),
                )}
              >
                <span
                  className={clsx(
                    'absolute top-1/2 block h-0.5 w-full -translate-y-1/2',
                    getColorBgSite(typeSite),
                  )}
                ></span>
              </span>
            </ButtonComponent>
          }
          backdrop={'opaque'}
          classNames={styles}
          placement={'bottom-end'}
          styleParent={{
            overflow: 'auto',
            borderRadius: '10px',
          }}
        >
          {(setIsOpen) => <BurgerMenuComponent close={() => setIsOpen(false)} />}
        </PopoverComponent>
      )}
    </>
  )
}

export default BurgerWrapperComponent
